var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { getMaskedString } from './get-masked-string';
var BLACK_LIST = ['Authorization'];
export var getFilteredHeaders = function (pureheaders) {
    return Object.keys(pureheaders).reduce(function (acc, headerKey) {
        var _a, _b;
        var headerValue = pureheaders[headerKey];
        if (BLACK_LIST.includes(headerKey)) {
            var maskedString = getMaskedString(headerValue);
            return __assign(__assign({}, acc), (_a = {}, _a[headerKey] = maskedString, _a));
        }
        return __assign(__assign({}, acc), (_b = {}, _b[headerKey] = headerValue, _b));
    }, {});
};
